import { useContext, useState } from "react"
import { PanelSessionContext } from "../../components/sessionContext"
import { SettingsContext } from "../../components/settingsContext";
import { Box, ButtonGroup, Card, Grid } from "@mui/material";
import Header from "../../components/misc/header";
import { MirrorDialogs } from "./mirrorDialogs";
import TableWrapper from "../../components/misc/tableWrapper";
import { DataGrid } from "@mui/x-data-grid";
import { min } from "moment";

const fieldColumns = [
    { field: "id", headerName: "ID" },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "scriptPath", headerName: "Script Path", flex: 1 },
    { 
        field: "assetInterval", 
        headerName: "Asset Id Scope",  
        valueGetter: (params:any) => 
            params.row.settings?.assetIdInterval?.[0] ? `${params.row.settings?.assetIdInterval?.[0]} - ${params.row.settings?.assetIdInterval?.[1]}` : "No value",  
    }, { 
        field: "containerInterval",
        headerName: "Container Id Scope",  
        minWidth: 120,
        valueGetter: (params:any) => 
            params.row.settings?.containerIdInterval?.[0] ? `${params.row.settings?.containerIdInterval?.[0]} - ${params.row.settings?.containerIdInterval?.[1]}` : "No value", 
    },
];

const MirrorsPage = () => {
    const session = useContext(PanelSessionContext);
    const settings = useContext(SettingsContext);

    const [selection, setSelection] = useState<number[]>([]);

    if (!settings.devMode) return <Box m="20px">
        <Header title="Mirrors" subtitle="Mirrors are only available in development mode." />
        <Card sx={{ p: "20px" }}>
            <p>Mirrors are only available in development mode.</p>
        </Card>
    </Box>

    return <Box m="20px">
        <Header title="Mirrors" subtitle="Manage your mirrors here." />
        <Card sx={{ p: "20px" }}>
            <ButtonGroup variant="contained">
                <MirrorDialogs.Create />
                { selection.length === 1 && <MirrorDialogs.Edit mirror={session.mirrors.find(m => m.id === selection[0])!} />}
                { selection.length === 1 && <MirrorDialogs.Sync mirror={session.mirrors.find(m => m.id === selection[0])!} />}
                { selection.length > 0 && <MirrorDialogs.Delete ids={selection} /> }
            </ButtonGroup>
            <TableWrapper>
                <DataGrid 
                    rows={session.mirrors} 
                    columns={fieldColumns}
                    onRowSelectionModelChange={(newSelection) => {
                        setSelection(newSelection as number[]);
                    }}
                    rowSelectionModel={selection}
                    checkboxSelection
                />
            </TableWrapper>
        </Card>
    </Box>
}

export default MirrorsPage;